"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Log_1 = __importDefault(require("./Log"));
var isUndef_1 = __importDefault(require("licia/isUndef"));
var perfNow_1 = __importDefault(require("licia/perfNow"));
var now_1 = __importDefault(require("licia/now"));
var isStr_1 = __importDefault(require("licia/isStr"));
var extend_1 = __importDefault(require("licia/extend"));
var uniqId_1 = __importDefault(require("licia/uniqId"));
var isRegExp_1 = __importDefault(require("licia/isRegExp"));
var isFn_1 = __importDefault(require("licia/isFn"));
var Stack_1 = __importDefault(require("licia/Stack"));
var isEmpty_1 = __importDefault(require("licia/isEmpty"));
var contain_1 = __importDefault(require("licia/contain"));
var copy_1 = __importDefault(require("licia/copy"));
var each_1 = __importDefault(require("licia/each"));
var toArr_1 = __importDefault(require("licia/toArr"));
var keys_1 = __importDefault(require("licia/keys"));
var last_1 = __importDefault(require("licia/last"));
var throttle_1 = __importDefault(require("licia/throttle"));
var xpath_1 = __importDefault(require("licia/xpath"));
var lowerCase_1 = __importDefault(require("licia/lowerCase"));
var dateFormat_1 = __importDefault(require("licia/dateFormat"));
var isHidden_1 = __importDefault(require("licia/isHidden"));
var stripIndent_1 = __importDefault(require("licia/stripIndent"));
var ResizeSensor_1 = __importDefault(require("licia/ResizeSensor"));
var util_1 = require("../share/util");
var Component_1 = __importDefault(require("../share/Component"));
var raf = require("licia/raf");
var u = navigator.userAgent;
var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1;
var c = (0, util_1.classPrefix)('console');
var id = 0;
var Console = (function (_super) {
    __extends(Console, _super);
    function Console(container, options) {
        if (options === void 0) { options = {}; }
        var _this = _super.call(this, container, { compName: 'console' }, options) || this;
        _this.spaceHeight = 0;
        _this.topSpaceHeight = 0;
        _this.bottomSpaceHeight = 0;
        _this.lastScrollTop = 0;
        _this.lastTimestamp = 0;
        _this.speedToleranceFactor = 100;
        _this.maxSpeedTolerance = 2000;
        _this.minSpeedTolerance = 100;
        _this.logs = [];
        _this.displayLogs = [];
        _this.timer = {};
        _this.counter = {};
        _this.asyncList = [];
        _this.asyncTimer = null;
        _this.isAtBottom = true;
        _this.groupStack = new Stack_1.default();
        _this.onScroll = function () {
            var _a = _this
                .container, scrollHeight = _a.scrollHeight, offsetHeight = _a.offsetHeight, scrollTop = _a.scrollTop;
            if (scrollTop <= 0)
                return;
            if (offsetHeight + scrollTop > scrollHeight)
                return;
            var isAtBottom = false;
            if (scrollHeight === offsetHeight) {
                isAtBottom = true;
            }
            else if (scrollTop === scrollHeight - offsetHeight) {
                isAtBottom = true;
            }
            _this.isAtBottom = isAtBottom;
            var lastScrollTop = _this.lastScrollTop;
            var lastTimestamp = _this.lastTimestamp;
            var timestamp = (0, now_1.default)();
            var duration = timestamp - lastTimestamp;
            var distance = scrollTop - lastScrollTop;
            var speed = Math.abs(distance / duration);
            var speedTolerance = speed * _this.speedToleranceFactor;
            if (duration > 1000) {
                speedTolerance = 1000;
            }
            if (speedTolerance > _this.maxSpeedTolerance) {
                speedTolerance = _this.maxSpeedTolerance;
            }
            if (speedTolerance < _this.minSpeedTolerance) {
                speedTolerance = _this.minSpeedTolerance;
            }
            _this.lastScrollTop = scrollTop;
            _this.lastTimestamp = timestamp;
            var topTolerance = 0;
            var bottomTolerance = 0;
            if (lastScrollTop < scrollTop) {
                topTolerance = _this.minSpeedTolerance;
                bottomTolerance = speedTolerance;
            }
            else {
                topTolerance = speedTolerance;
                bottomTolerance = _this.minSpeedTolerance;
            }
            if (_this.topSpaceHeight < scrollTop - topTolerance &&
                _this.topSpaceHeight + _this.el.offsetHeight >
                    scrollTop + offsetHeight + bottomTolerance) {
                return;
            }
            _this.renderViewport({
                topTolerance: topTolerance * 2,
                bottomTolerance: bottomTolerance * 2,
            });
        };
        _this.initTpl();
        _this.initOptions(options, {
            maxNum: 0,
            asyncRender: true,
            showHeader: false,
            filter: 'all',
            accessGetter: false,
            unenumerable: true,
            lazyEvaluation: true,
        });
        _this.$el = _this.find('.logs');
        _this.el = _this.$el.get(0);
        _this.$fakeEl = _this.find('.fake-logs');
        _this.fakeEl = _this.$fakeEl.get(0);
        _this.$space = _this.find('.logs-space');
        _this.space = _this.$space.get(0);
        if (isAndroid) {
            _this.speedToleranceFactor = 800;
            _this.maxSpeedTolerance = 3000;
            _this.minSpeedTolerance = 800;
        }
        _this.resizeSensor = new ResizeSensor_1.default(container);
        _this.renderViewport = (0, throttle_1.default)(function (options) {
            _this._renderViewport(options);
        }, 16);
        _this.global = {
            copy: function (value) {
                if (!(0, isStr_1.default)(value))
                    value = JSON.stringify(value, null, 2);
                (0, copy_1.default)(value);
            },
            $: function (selectors) {
                return document.querySelector(selectors);
            },
            $$: function (selectors) {
                return (0, toArr_1.default)(document.querySelectorAll(selectors));
            },
            $x: function (path) {
                return (0, xpath_1.default)(path);
            },
            clear: function () {
                _this.clear();
            },
            dir: function (value) {
                _this.dir(value);
            },
            table: function (data, columns) {
                _this.table(data, columns);
            },
            keys: keys_1.default,
        };
        _this.bindEvent();
        return _this;
    }
    Console.prototype.setGlobal = function (name, val) {
        this.global[name] = val;
    };
    Console.prototype.destroy = function () {
        this.$container.off('scroll', this.onScroll);
        this.resizeSensor.destroy();
        _super.prototype.destroy.call(this);
    };
    Console.prototype.count = function (label) {
        if (label === void 0) { label = 'default'; }
        var counter = this.counter;
        !(0, isUndef_1.default)(counter[label]) ? counter[label]++ : (counter[label] = 1);
        this.info("".concat(label, ": ").concat(counter[label]));
    };
    Console.prototype.countReset = function (label) {
        if (label === void 0) { label = 'default'; }
        this.counter[label] = 0;
    };
    Console.prototype.assert = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if ((0, isEmpty_1.default)(args))
            return;
        var exp = args.shift();
        if (!exp) {
            if (args.length === 0)
                args.unshift('console.assert');
            args.unshift('Assertion failed: ');
            this.insert('error', args);
        }
    };
    Console.prototype.log = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if ((0, isEmpty_1.default)(args))
            return;
        this.insert('log', args);
    };
    Console.prototype.debug = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if ((0, isEmpty_1.default)(args))
            return;
        this.insert('debug', args);
    };
    Console.prototype.dir = function (obj) {
        if ((0, isUndef_1.default)(obj))
            return;
        this.insert('dir', [obj]);
    };
    Console.prototype.table = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if ((0, isEmpty_1.default)(args))
            return;
        this.insert('table', args);
    };
    Console.prototype.time = function (name) {
        if (name === void 0) { name = 'default'; }
        if (this.timer[name]) {
            return this.insert('warn', ["Timer '".concat(name, "' already exists")]);
        }
        this.timer[name] = (0, perfNow_1.default)();
    };
    Console.prototype.timeLog = function (name) {
        if (name === void 0) { name = 'default'; }
        var startTime = this.timer[name];
        if (!startTime) {
            return this.insert('warn', ["Timer '".concat(name, "' does not exist")]);
        }
        this.info("".concat(name, ": ").concat((0, perfNow_1.default)() - startTime, "ms"));
    };
    Console.prototype.timeEnd = function (name) {
        if (name === void 0) { name = 'default'; }
        this.timeLog(name);
        delete this.timer[name];
    };
    Console.prototype.clear = function (silent) {
        if (silent === void 0) { silent = false; }
        this.logs = [];
        this.displayLogs = [];
        this.lastLog = undefined;
        this.counter = {};
        this.timer = {};
        this.groupStack = new Stack_1.default();
        this.asyncList = [];
        if (this.asyncTimer) {
            clearTimeout(this.asyncTimer);
            this.asyncTimer = null;
        }
        if (silent) {
            this.render();
        }
        else {
            this.insert('log', [
                '%cConsole was cleared',
                'color:#808080;font-style:italic;',
            ]);
        }
    };
    Console.prototype.info = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if ((0, isEmpty_1.default)(args))
            return;
        this.insert('log', args);
    };
    Console.prototype.error = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if ((0, isEmpty_1.default)(args))
            return;
        this.insert('error', args);
    };
    Console.prototype.warn = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if ((0, isEmpty_1.default)(args))
            return;
        this.insert('warn', args);
    };
    Console.prototype.group = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        this.insert({
            type: 'group',
            args: args,
            ignoreFilter: true,
        });
    };
    Console.prototype.groupCollapsed = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        this.insert({
            type: 'groupCollapsed',
            args: args,
            ignoreFilter: true,
        });
    };
    Console.prototype.groupEnd = function () {
        this.insert('groupEnd');
    };
    Console.prototype.evaluate = function (code) {
        this.insert({
            type: 'input',
            args: [code],
            ignoreFilter: true,
        });
        try {
            this.output(this.evalJs(code));
        }
        catch (e) {
            this.insert({
                type: 'error',
                ignoreFilter: true,
                args: [e],
            });
        }
    };
    Console.prototype.html = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        this.insert('html', args);
    };
    Console.prototype.toggleGroup = function (log) {
        var targetGroup = log.targetGroup;
        targetGroup.collapsed
            ? this.openGroup(log)
            : this.collapseGroup(log);
    };
    Console.prototype.output = function (val) {
        this.insert({
            type: 'output',
            args: [val],
            ignoreFilter: true,
        });
    };
    Console.prototype.render = function () {
        var logs = this.logs;
        this.$el.html('');
        this.isAtBottom = true;
        this.updateBottomSpace(0);
        this.updateTopSpace(0);
        this.displayLogs = [];
        for (var i = 0, len = logs.length; i < len; i++) {
            this.attachLog(logs[i]);
        }
    };
    Console.prototype.insert = function (type, args) {
        var _a = this.options, showHeader = _a.showHeader, asyncRender = _a.asyncRender;
        var header;
        if (showHeader) {
            header = {
                time: getCurTime(),
                from: getFrom(),
            };
        }
        if (asyncRender) {
            return this.insertAsync(type, args, header);
        }
        this.insertSync(type, args, header);
    };
    Console.prototype.insertAsync = function (type, args, header) {
        this.asyncList.push([type, args, header]);
        this.handleAsyncList();
    };
    Console.prototype.insertSync = function (type, args, header) {
        var _this = this;
        var _a = this, logs = _a.logs, groupStack = _a.groupStack;
        var _b = this.options, maxNum = _b.maxNum, accessGetter = _b.accessGetter, unenumerable = _b.unenumerable, lazyEvaluation = _b.lazyEvaluation;
        var options;
        if ((0, isStr_1.default)(type)) {
            options = {
                type: type,
                args: args,
                header: header,
            };
        }
        else {
            options = type;
        }
        if (options.type === 'groupEnd') {
            var lastLog_1 = this.lastLog;
            lastLog_1.groupEnd();
            this.groupStack.pop();
            return;
        }
        if (groupStack.size > 0) {
            options.group = groupStack.peek();
        }
        (0, extend_1.default)(options, {
            id: ++id,
            accessGetter: accessGetter,
            unenumerable: unenumerable,
            lazyEvaluation: lazyEvaluation,
        });
        if (options.type === 'group' || options.type === 'groupCollapsed') {
            var group = {
                id: (0, uniqId_1.default)('group'),
                collapsed: false,
                parent: groupStack.peek(),
                indentLevel: groupStack.size + 1,
            };
            if (options.type === 'groupCollapsed')
                group.collapsed = true;
            options.targetGroup = group;
            groupStack.push(group);
        }
        var log = new Log_1.default(this, options);
        log.on('updateSize', function () {
            _this.isAtBottom = false;
            _this.renderViewport();
        });
        var lastLog = this.lastLog;
        if (lastLog &&
            !(0, contain_1.default)(['html', 'group', 'groupCollapsed'], log.type) &&
            lastLog.type === log.type &&
            !log.src &&
            !log.args &&
            lastLog.text() === log.text()) {
            lastLog.addCount();
            if (log.header)
                lastLog.updateTime(log.header.time);
            log = lastLog;
            this.detachLog(lastLog);
        }
        else {
            logs.push(log);
            this.lastLog = log;
        }
        if (maxNum !== 0 && logs.length > maxNum) {
            var firstLog = logs[0];
            this.detachLog(firstLog);
            logs.shift();
        }
        this.attachLog(log);
        this.emit('insert', log);
    };
    Console.prototype.updateTopSpace = function (height) {
        this.topSpaceHeight = height;
        this.el.style.top = height + 'px';
    };
    Console.prototype.updateBottomSpace = function (height) {
        this.bottomSpaceHeight = height;
    };
    Console.prototype.updateSpace = function (height) {
        if (this.spaceHeight === height)
            return;
        this.spaceHeight = height;
        this.space.style.height = height + 'px';
    };
    Console.prototype.detachLog = function (log) {
        var displayLogs = this.displayLogs;
        var idx = displayLogs.indexOf(log);
        if (idx > -1) {
            displayLogs.splice(idx, 1);
            this.renderViewport();
        }
    };
    Console.prototype.attachLog = function (log) {
        if (!this.filterLog(log) || log.collapsed)
            return;
        var displayLogs = this.displayLogs;
        if (displayLogs.length === 0) {
            displayLogs.push(log);
            this.renderViewport();
            return;
        }
        var lastDisplayLog = (0, last_1.default)(displayLogs);
        if (log.id > lastDisplayLog.id) {
            displayLogs.push(log);
            this.renderViewport();
            return;
        }
        var startIdx = 0;
        var endIdx = displayLogs.length - 1;
        var middleLog;
        var middleIdx = 0;
        while (startIdx <= endIdx) {
            middleIdx = startIdx + Math.floor((endIdx - startIdx) / 2);
            middleLog = displayLogs[middleIdx];
            if (middleLog.id === log.id) {
                return;
            }
            if (middleLog.id < log.id) {
                startIdx = middleIdx + 1;
            }
            else {
                endIdx = middleIdx - 1;
            }
        }
        if (middleLog.id < log.id) {
            displayLogs.splice(middleIdx + 1, 0, log);
        }
        else {
            displayLogs.splice(middleIdx, 0, log);
        }
        this.renderViewport();
    };
    Console.prototype.handleAsyncList = function (timeout) {
        var _this = this;
        if (timeout === void 0) { timeout = 20; }
        var asyncList = this.asyncList;
        if (this.asyncTimer)
            return;
        this.asyncTimer = setTimeout(function () {
            _this.asyncTimer = null;
            var done = false;
            var len = asyncList.length;
            var timeout, num;
            if (len < 1000) {
                num = 200;
                timeout = 400;
            }
            else if (len < 5000) {
                num = 500;
                timeout = 800;
            }
            else if (len < 10000) {
                num = 800;
                timeout = 1000;
            }
            else if (len < 25000) {
                num = 1000;
                timeout = 1200;
            }
            else if (len < 50000) {
                num = 1500;
                timeout = 1500;
            }
            else {
                num = 2000;
                timeout = 2500;
            }
            if (num > len) {
                num = len;
                done = true;
            }
            for (var i = 0; i < num; i++) {
                var _a = __read(asyncList.shift(), 3), type = _a[0], args = _a[1], header = _a[2];
                _this.insertSync(type, args, header);
            }
            if (!done) {
                raf(function () { return _this.handleAsyncList(timeout); });
            }
        }, timeout);
    };
    Console.prototype.injectGlobal = function () {
        (0, each_1.default)(this.global, function (val, name) {
            if (window[name])
                return;
            window[name] = val;
        });
    };
    Console.prototype.clearGlobal = function () {
        (0, each_1.default)(this.global, function (val, name) {
            if (window[name] && window[name] === val) {
                delete window[name];
            }
        });
    };
    Console.prototype.evalJs = function (jsInput) {
        var ret;
        this.injectGlobal();
        try {
            ret = eval.call(window, "(".concat(jsInput, ")"));
        }
        catch (e) {
            ret = eval.call(window, jsInput);
        }
        this.setGlobal('$_', ret);
        this.clearGlobal();
        return ret;
    };
    Console.prototype.filterLog = function (log) {
        var filter = this.options.filter;
        if (filter === 'all')
            return true;
        if (log.ignoreFilter) {
            return true;
        }
        if ((0, isFn_1.default)(filter)) {
            return filter(log);
        }
        if ((0, isRegExp_1.default)(filter)) {
            return filter.test((0, lowerCase_1.default)(log.text()));
        }
        return log.type === filter;
    };
    Console.prototype.collapseGroup = function (log) {
        var targetGroup = log.targetGroup;
        targetGroup.collapsed = true;
        log.updateIcon('caret-right');
        this.updateGroup(log);
    };
    Console.prototype.openGroup = function (log) {
        var targetGroup = log.targetGroup;
        targetGroup.collapsed = false;
        log.updateIcon('caret-down');
        this.updateGroup(log);
    };
    Console.prototype.updateGroup = function (log) {
        var targetGroup = log.targetGroup;
        var logs = this.logs;
        var len = logs.length;
        var i = logs.indexOf(log) + 1;
        while (i < len) {
            var log_1 = logs[i];
            if (!log_1.checkGroup() && log_1.group === targetGroup) {
                break;
            }
            log_1.collapsed ? this.detachLog(log_1) : this.attachLog(log_1);
            i++;
        }
    };
    Console.prototype.bindEvent = function () {
        var _this = this;
        var $el = this.$el;
        this.resizeSensor.addListener(this.renderViewport);
        $el.on('click', c('.log-container'), function () {
            this.log.click();
        });
        this.on('optionChange', function (name, val) {
            var logs = _this.logs;
            switch (name) {
                case 'maxNum':
                    if (val > 0 && logs.length > val) {
                        _this.logs = logs.slice(logs.length - val);
                        _this.render();
                    }
                    break;
                case 'filter':
                    _this.render();
                    break;
            }
        });
        this.$container.on('scroll', this.onScroll);
    };
    Console.prototype._renderViewport = function (_a) {
        var _b = _a === void 0 ? {} : _a, _c = _b.topTolerance, topTolerance = _c === void 0 ? 500 : _c, _d = _b.bottomTolerance, bottomTolerance = _d === void 0 ? 500 : _d;
        var _e = this, el = _e.el, container = _e.container;
        if ((0, isHidden_1.default)(container))
            return;
        var _f = container, scrollTop = _f.scrollTop, offsetHeight = _f.offsetHeight;
        var containerWidth = container.getBoundingClientRect().width;
        var top = scrollTop - topTolerance;
        var bottom = scrollTop + offsetHeight + bottomTolerance;
        var displayLogs = this.displayLogs;
        var topSpaceHeight = 0;
        var bottomSpaceHeight = 0;
        var currentHeight = 0;
        var len = displayLogs.length;
        var fakeEl = this.fakeEl;
        var fakeFrag = document.createDocumentFragment();
        var logs = [];
        for (var i = 0; i < len; i++) {
            var log = displayLogs[i];
            var width = log.width, height = log.height;
            if (height === 0 || width !== containerWidth) {
                fakeFrag.appendChild(log.container);
                logs.push(log);
            }
        }
        if (logs.length > 0) {
            fakeEl.appendChild(fakeFrag);
            for (var i = 0, len_1 = logs.length; i < len_1; i++) {
                logs[i].updateSize();
            }
            fakeEl.innerHTML = '';
        }
        var frag = document.createDocumentFragment();
        for (var i = 0; i < len; i++) {
            var log = displayLogs[i];
            var container_1 = log.container, height = log.height;
            if (currentHeight > bottom) {
                bottomSpaceHeight += height;
            }
            else if (currentHeight + height > top) {
                frag.appendChild(container_1);
            }
            else if (currentHeight < top) {
                topSpaceHeight += height;
            }
            currentHeight += height;
        }
        this.updateSpace(currentHeight);
        this.updateTopSpace(topSpaceHeight);
        this.updateBottomSpace(bottomSpaceHeight);
        while (el.firstChild) {
            if (el.lastChild) {
                el.removeChild(el.lastChild);
            }
        }
        el.appendChild(frag);
        var scrollHeight = container.scrollHeight;
        if (this.isAtBottom && scrollTop <= scrollHeight - offsetHeight) {
            container.scrollTop = 10000000;
        }
    };
    Console.prototype.initTpl = function () {
        this.$container.html(this.c((0, stripIndent_1.default)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      <div class=\"logs-space\">\n        <div class=\"fake-logs\"></div>\n        <div class=\"logs\"></div>\n      </div>\n    "], ["\n      <div class=\"logs-space\">\n        <div class=\"fake-logs\"></div>\n        <div class=\"logs\"></div>\n      </div>\n    "])))));
    };
    return Console;
}(Component_1.default));
exports.default = Console;
module.exports = Console;
module.exports.default = Console;
var getCurTime = function () { return (0, dateFormat_1.default)('HH:MM:ss '); };
function getFrom() {
    var e = new Error();
    var ret = '';
    var lines = e.stack ? e.stack.split('\n') : '';
    for (var i = 0, len = lines.length; i < len; i++) {
        ret = lines[i];
        if (ret.indexOf('winConsole') > -1 && i < len - 1) {
            ret = lines[i + 1];
            break;
        }
    }
    return ret;
}
var templateObject_1;
